/**
 * Font choices for the Theme Studio font knob.
 *
 * Adapted (NOT byte-mirrored) from popin-rn `utils/fontPairs.ts` @ origin/main —
 * the upstream file wires each pair to a bundled `.ttf` via a Metro `require()`,
 * which is native/RN-only and can't be imported here. The portal is a *sender*:
 * it only needs the `id`/`label` list to drive the knob, and it passes the chosen
 * `fontId` string over the v2 preview channel — the embedded app resolves the
 * real `BrandFonts` from its own `FONT_PAIRS`. So we keep just id + label + a
 * web-only `previewFamily` for the knob's on-page type sample.
 *
 * Keep the `id`s in lock-step with popin-rn `FONT_PAIRS[].id`.
 */

export interface FontChoice {
  /** Must match popin-rn `FONT_PAIRS[].id`. Sent as `recipe.fontId`. */
  id: string;
  label: string;
  /** CSS font-family used only for the on-page knob preview (portal-side). */
  previewFamily: string;
}

export const FONT_CHOICES: FontChoice[] = [
  { id: "default", label: "pop.in", previewFamily: "var(--font-sans)" },
  { id: "mono", label: "Space Mono", previewFamily: "var(--font-mono)" },
  { id: "mono-display", label: "Mono display", previewFamily: "var(--font-mono)" },
];

export const DEFAULT_FONT_ID = "default";

export function fontLabel(id: string): string {
  return FONT_CHOICES.find((f) => f.id === id)?.label ?? id;
}
